import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useLanguage } from "../lib/LanguageContext";
import { langToLocale } from "../lib/utils/locale";
const formatValue = (value, format, unit, locale) => {
    if (format === "money") {
        const formatted = value.toLocaleString(locale, { maximumFractionDigits: 0 });
        return unit ? `${formatted} ${unit}` : formatted;
    }
    return value.toLocaleString(locale, { maximumFractionDigits: 0 });
};
export const LimitUsageBar = ({ label, used, limit, unit = "", format = "money", }) => {
    const { t, lang } = useLanguage();
    const locale = langToLocale(lang);
    const safeLimit = limit > 0 ? limit : 0;
    const pct = safeLimit > 0 ? Math.min(100, (used / safeLimit) * 100) : used > 0 ? 100 : 0;
    const exhausted = safeLimit > 0 ? used >= safeLimit : used > 0;
    const warning = !exhausted && pct >= 85;
    const barClass = exhausted
        ? "bg-rose-500"
        : warning
            ? "bg-amber-500"
            : "bg-emerald-500";
    const textClass = exhausted
        ? "text-rose-600 dark:text-rose-400"
        : warning
            ? "text-amber-600 dark:text-amber-400"
            : "text-foreground";
    return (_jsxs("div", { className: `rounded-lg border px-3 py-2 ${exhausted
            ? "border-rose-300 bg-rose-50 dark:border-rose-900/60 dark:bg-rose-950/30"
            : warning
                ? "border-amber-300 bg-amber-50 dark:border-amber-900/60 dark:bg-amber-950/20"
                : "border-border bg-muted/30"}`, children: [_jsxs("div", { className: "mb-1 flex flex-wrap items-baseline justify-between gap-2 text-sm", children: [_jsx("span", { className: "text-muted-foreground", children: label }), _jsxs("span", { className: `font-medium ${textClass}`, children: [formatValue(used, format, unit, locale), " / ", formatValue(safeLimit, format, unit, locale), _jsxs("span", { className: "ml-2 text-xs text-muted-foreground", children: ["(", pct.toFixed(0), "%)"] })] })] }), _jsx("div", { className: "h-2 overflow-hidden rounded-full bg-muted", children: _jsx("div", { className: `h-full rounded-full transition-all ${barClass}`, style: { width: `${pct}%` } }) }), exhausted ? (_jsx("p", { className: "mt-1.5 text-xs font-medium text-rose-600 dark:text-rose-400", children: t("limits.exhausted") })) : warning ? (_jsx("p", { className: "mt-1.5 text-xs text-amber-600 dark:text-amber-400", children: t("limits.warning") })) : null] }));
};
